export const ATTENDANCE_BIOMETRIC_PREVIEW_ASPECT_CLASS = 'aspect-[4/5]';

export const ATTENDANCE_BIOMETRIC_FACE_GUIDE_DIMENSIONS = {
  width: 200,
  height: 260,
} as const;